import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import AccountingSync from './AccountingSync';

interface Connection { connected: boolean; verified?: boolean; companyName?: string; checkedAt?: string; error?: string; accounting?: any; refreshTokenExpired?: boolean; accessTokenExpired?: boolean }

export default function IntegrationSettings() {
  const { user } = useAuth();
  const [connection, setConnection] = useState<Connection | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (user?.role !== 'admin') return;
    let active = true;
    api.get('/quickbooks/status').then(({ data }) => { if (active) setConnection(data); })
      .catch(() => { if (active) setError('Unable to load the QuickBooks connection. Try again later.'); });
    return () => { active = false; };
  }, [user?.role]);
  if (user?.role !== 'admin') return <div role="alert" style={{ padding: 24, color: '#fff' }}>Only an administrator can manage integrations.</div>;
  const connect = async () => {
    setBusy(true); setError('');
    try {
      const { data } = await api.get('/quickbooks/connect?format=json', { withCredentials: true });
      const target = new URL(data.url);
      if (target.protocol !== 'https:' || target.hostname !== 'appcenter.intuit.com') throw new Error('Invalid authorization URL');
      window.location.assign(target.href);
    } catch { setError('Unable to start authorization. Open the primary CRM website and try again.'); setBusy(false); }
  };
  const refresh = async () => { const {data}=await api.get('/quickbooks/status');setConnection(data); };
  const result = new URLSearchParams(window.location.search).get('qb');
  return <div style={{ padding: 24, color: '#f1f5f9', maxWidth: 720 }}>
    <h1>Integrations</h1>
    <section style={{ padding: 24, border: '1px solid #2D4259', borderRadius: 14, background: '#1A2B3C' }}>
      <h2>QuickBooks</h2>
      {result === 'connected' && <p role="status">Authorization completed. The connection status is shown below.</p>}
      {result === 'error' && <p role="alert">Authorization did not complete. Please reconnect.</p>}
      {connection?.error && <p role="alert">{connection.error}</p>}
      {connection?.verified && <p>Verified with {connection.companyName} at {new Date(connection.checkedAt!).toLocaleString()}.</p>}
      {connection && <p>{connection.connected ? (connection.refreshTokenExpired ? 'Reconnect required: the saved authorization has expired.' : 'Connected') : 'Not connected'}</p>}
      {!connection && !error && <p>Loading connection…</p>}
      {error && <p role="alert">{error}</p>}
      <button onClick={connect} disabled={busy} style={{ padding: '10px 16px', borderRadius: 8, cursor: 'pointer' }}>{busy ? 'Opening QuickBooks…' : connection?.connected ? 'Reconnect QuickBooks' : 'Connect QuickBooks'}</button>
    </section>
    {connection && <AccountingSync connection={connection} onRefresh={refresh}/>}
  </div>;
}
